import { useEffect, useState } from "react";
import axios from "axios";

import { getToken } from "../../../utils/tokenStorage";
import { rotuloPagamento } from "./pagamentoRotulo";

// Formas de pagamento cadastradas pela loja, carregadas UMA vez por aba e
// guardadas aqui. O pedido grava o código ("dinheiro_<id da loja>"), que é só
// interno (dono, 30/09/2026): tudo que aparece na tela ou no cupom sai pelo nome
// que a loja deu à forma. Quem não é componente React (cupom montado em texto)
// lê o que já foi carregado com `nomeFormaAgora`; sem lista, `rotuloPagamento`
// ainda tira o código ("Dinheiro").
let mapa = null;
let carregando = null;

export function carregarFormasDaLoja() {
  if (mapa) return Promise.resolve(mapa);
  if (!carregando) {
    const tok = getToken();
    carregando = axios
      .get("/api/payment-methods", { headers: tok ? { Authorization: `Bearer ${tok}` } : {} })
      .then((res) => {
        const m = {};
        for (const f of res.data || []) {
          if (f?.code) { m[f.code] = f; m[String(f.code).toLowerCase()] = f; }
          if (f?.id) m[f.id] = f;
        }
        mapa = m;
        return m;
      })
      .catch(() => { carregando = null; return {}; });
  }
  return carregando;
}

export function nomeFormaAgora(valor) {
  return rotuloPagamento(valor, mapa || {});
}

/** Função `(código) => nome` que se atualiza quando a lista chega. */
export function useNomeForma() {
  const [m, setM] = useState(mapa || {});
  useEffect(() => {
    let vivo = true;
    carregarFormasDaLoja().then((x) => vivo && setM(x));
    return () => { vivo = false; };
  }, []);
  return (valor) => rotuloPagamento(valor, m);
}

/** "dinheiro_<loja>", "Dinheiro" ou "dinheiro" → "dinheiro" (para regras como o troco). */
export function formaBase(valor) {
  const t = String(valor || "").trim().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  return t.replace(/_[0-9a-f]{8}-[0-9a-f-]{20,}$/i, "");
}
